export default __webpack_public_path__ + "static/media/Guan.3136a493.mp4";